import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReferenceHistoryRoute = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M10 17H9a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v5M3 8v11a2 2 0 0 0 2 2h4" }),
		/* @__PURE__ */ _jsx("circle", {
			cx: 14,
			cy: 7.5,
			r: 2
		}),
		/* @__PURE__ */ _jsx("path", { d: "M10.5 17v-1.5A3.5 3.5 0 0 1 14 12" }),
		/* @__PURE__ */ _jsx("circle", {
			cx: 18,
			cy: 18,
			r: 4.5
		}),
		/* @__PURE__ */ _jsx("path", { d: "M18 15.8v2.5l1.6 1" })
	]
});
export default SvgReferenceHistoryRoute;
